import actions from "./actions";

const initState = {
    defaultCurrency: "$",

    loginData: null,
    loginLoading: false,
    loginMessage: null,
    loginError: null,

    verifyOtpresult: null,
    verifyOtpLoading: false,
    verifyOtpMessage: null,
    verifyOtpError: null,

    loading: false,
    tokenData: [],
    tokenError: null,

    forgotPasswordLoading: false,
    forgotPasswordMessage: null,
    forgotPasswordError: null,

    resetPasswordLoading: false,
    resetPasswordMessage: null,
    resetPasswordError: null,

    fundManagementLoading: false,
    fundManagementError: null,
    fundManagementMessage: null,

    getLatestFundManagementLoading: false,
    getLatestFundManagementError: null,
    getLatestFundManagementList: [],
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.LOGIN:
            return {
                ...state,
                loginLoading: true,
                loginMessage: null,
                loginError: null,
            };
        case actions.LOGIN_SUCCESS:
            return {
                ...state,
                loginLoading: false,
                loginData: action.payload.data,
                loginMessage: action.payload.message,
                loginError: null,
            };
        case actions.LOGIN_FAILED:
            return {
                ...state,
                loginLoading: false,
                loginMessage: null,
                loginError: action.payload.error,
            };

        case actions.VERIFY_OTP:
            return {
                ...state,
                verifyOtpLoading: true,
                verifyOtpMessage: null,
                verifyOtpError: null,
            };
        case actions.VERIFY_OTP_SUCCESS:
            return {
                ...state,
                verifyOtpLoading: false,
                verifyOtpresult: action.payload.result,
                verifyOtpMessage: action.payload.message,
                verifyOtpError: null,
            };
        case actions.VERIFY_OTP_FAILED:
            return {
                ...state,
                verifyOtpLoading: false,
                verifyOtpMessage: null,
                verifyOtpError: action.payload.error,
            };

        case actions.GET_USER_DATA_BY_TOKEN:
            return {
                ...state,
                loading: true,
                tokenError: null
            };
        case actions.GET_USER_DATA_BY_TOKEN_SUCCESS:
            return {
                ...state,
                loading: false,
                tokenData: action.tokenData
            };
        case actions.GET_USER_DATA_BY_TOKEN_FAILED:
            return {
                ...state,
                loading: false,
                tokenError: action.tokenError
            };

        case actions.FORGOT_PASSWORD:
            return {
                ...state,
                forgotPasswordLoading: true,
                forgotPasswordMessage: null,
                forgotPasswordError: null,
            };
        case actions.FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                forgotPasswordLoading: false,
                forgotPasswordMessage: action.payload.message,
                forgotPasswordError: null,
            };
        case actions.FORGOT_PASSWORD_FAILED:
            return {
                ...state,
                forgotPasswordLoading: false,
                forgotPasswordMessage: null,
                forgotPasswordError: action.payload.error,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                loginMessage: null,
                loginError: null,
                verifyOtpMessage: null,
                verifyOtpError: null,
                forgotPasswordMessage: null,
                forgotPasswordError: null,
                forgotPasswordReqMessage: null,
                forgotPasswordReqError: null,
                resetPasswordMessage: null,
                resetPasswordError: null,
                fundManagementMessage: null,
                fundManagementError: null,
            };

        case actions.RESET_PASSWORD:
            return {
                ...state,
                resetPasswordLoading: true,
                resetPasswordMessage: null,
                resetPasswordError: null,
            };
        case actions.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPasswordLoading: false,
                resetPasswordMessage: action.payload.message,
                resetPasswordError: null,
            };
        case actions.RESET_PASSWORD_FAILED:
            return {
                ...state,
                resetPasswordLoading: false,
                resetPasswordMessage: null,
                resetPasswordError: action.payload.error,
            };
        // Fund management
        case actions.FUND_MANAGEMENT:
            return {
                ...state,
                fundManagementLoading: true,
                fundManagementError: null,
                fundManagementMessage: null,
            };

        case actions.FUND_MANAGEMENT_SUCCESS:
            return {
                ...state,
                fundManagementLoading: false,
                fundManagementError: null,
                fundManagementMessage: action.message,
            };

        case actions.FUND_MANAGEMENT_FAILED:
            return {
                ...state,
                fundManagementLoading: false,
                fundManagementError: action.error,
                fundManagementMessage: null,
            };

        case actions.GET_LATEST_FUND_MANAGEMENT_DATA:
            return {
                ...state,
                getLatestFundManagementLoading: true,
                getLatestFundManagementError: null,
                getLatestFundManagementList: [],
            };

        case actions.GET_LATEST_FUND_MANAGEMENT_DATA_SUCCESS:
            return {
                ...state,
                getLatestFundManagementLoading: false,
                getLatestFundManagementError: null,
                getLatestFundManagementList: action.payload.data,
            };

        case actions.GET_LATEST_FUND_MANAGEMENT_DATA_FAILED:
            return {
                ...state,
                getLatestFundManagementLoading: false,
                getLatestFundManagementError: action.error,
            };

        default:
            return state;
    }
}
